var _linearGradient, _path, _path2, _path3, _linearGradient2, _path4, _linearGradient3, _path5, _linearGradient4, _path6, _linearGradient5, _path7, _linearGradient6, _path8, _linearGradient7, _path9, _linearGradient8, _path10, _linearGradient9, _path11, _linearGradient10, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeneralLedger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 198.425 198.425",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_0_70688395b09a45ef61cd4b7e91a28081d507a2de75a0cdd63f27cfc7a6abe212",
    gradientUnits: "userSpaceOnUse",
    x1: -1591.758,
    y1: -964.901,
    x2: -1590.758,
    y2: -964.901
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M95.638 119.965H58.654c-3.237 0-5.896-2.648-5.896-5.896V36.166c0-3.248 2.659-5.896 5.896-5.896h36.984M103.989 30.27h36.266a5.907 5.907 0 015.896 5.896v77.903a5.907 5.907 0 01-5.896 5.896h-36.266"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M52.758 45.964h-7.965a5.907 5.907 0 00-5.896 5.896v77.914c0 3.237 2.648 5.896 5.896 5.896h48.369M146.152 45.964h9.101a5.907 5.907 0 015.896 5.896v77.914c0 3.237-2.648 5.896-5.896 5.896H105.94M103.989 30.27v2.08c0 2.294-1.876 4.181-4.17 4.181s-4.181-1.887-4.181-4.181v-2.08M103.989 119.965v1.158c0 2.294-1.876 4.181-4.17 4.181s-4.181-1.887-4.181-4.181v-1.158M105.94 135.67a6.415 6.415 0 01-1.812 3.484 6.44 6.44 0 01-4.577 1.908c-3.195 0-5.864-2.348-6.389-5.392"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke",
    d: "M129.832 51.271s-.885-5.118-5.118-5.118c-4.233 0-5.37 5.118-5.37 5.118l10.994 8.335M119.849 59.607s.885 5.118 5.118 5.118 5.37-5.118 5.37-5.118M124.841 41.794v4.359M124.841 64.724v4.36"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_70688395b09a45ef61cd4b7e91a28081d507a2de75a0cdd63f27cfc7a6abe212",
    gradientUnits: "userSpaceOnUse",
    x1: 62.008,
    y1: 63.842,
    x2: 90.468,
    y2: 63.842
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_1_70688395b09a45ef61cd4b7e91a28081d507a2de75a0cdd63f27cfc7a6abe212)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M63.258 58.6h25.96v10.484h-25.96z"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_70688395b09a45ef61cd4b7e91a28081d507a2de75a0cdd63f27cfc7a6abe212",
    gradientUnits: "userSpaceOnUse",
    x1: 62.008,
    y1: 90.048,
    x2: 90.468,
    y2: 90.048
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_2_70688395b09a45ef61cd4b7e91a28081d507a2de75a0cdd63f27cfc7a6abe212)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M89.218 90.048h-25.96"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_70688395b09a45ef61cd4b7e91a28081d507a2de75a0cdd63f27cfc7a6abe212",
    gradientUnits: "userSpaceOnUse",
    x1: 62.008,
    y1: 79.566,
    x2: 90.468,
    y2: 79.566
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_3_70688395b09a45ef61cd4b7e91a28081d507a2de75a0cdd63f27cfc7a6abe212)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M89.218 79.566h-25.96"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_70688395b09a45ef61cd4b7e91a28081d507a2de75a0cdd63f27cfc7a6abe212",
    gradientUnits: "userSpaceOnUse",
    x1: 62.008,
    y1: 111.013,
    x2: 90.468,
    y2: 111.013
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_4_70688395b09a45ef61cd4b7e91a28081d507a2de75a0cdd63f27cfc7a6abe212)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M89.218 111.013h-25.96"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_70688395b09a45ef61cd4b7e91a28081d507a2de75a0cdd63f27cfc7a6abe212",
    gradientUnits: "userSpaceOnUse",
    x1: 62.008,
    y1: 100.531,
    x2: 90.468,
    y2: 100.531
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_5_70688395b09a45ef61cd4b7e91a28081d507a2de75a0cdd63f27cfc7a6abe212)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M89.218 100.53h-25.96"
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_70688395b09a45ef61cd4b7e91a28081d507a2de75a0cdd63f27cfc7a6abe212",
    gradientUnits: "userSpaceOnUse",
    x1: 110.611,
    y1: 111.013,
    x2: 139.071,
    y2: 111.013
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_6_70688395b09a45ef61cd4b7e91a28081d507a2de75a0cdd63f27cfc7a6abe212)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M137.821 111.013h-25.96"
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_70688395b09a45ef61cd4b7e91a28081d507a2de75a0cdd63f27cfc7a6abe212",
    gradientUnits: "userSpaceOnUse",
    x1: 110.611,
    y1: 100.531,
    x2: 139.071,
    y2: 100.531
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_7_70688395b09a45ef61cd4b7e91a28081d507a2de75a0cdd63f27cfc7a6abe212)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M137.821 100.53h-25.96"
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_70688395b09a45ef61cd4b7e91a28081d507a2de75a0cdd63f27cfc7a6abe212",
    gradientUnits: "userSpaceOnUse",
    x1: 62.008,
    y1: 43.974,
    x2: 90.468,
    y2: 43.974
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_8_70688395b09a45ef61cd4b7e91a28081d507a2de75a0cdd63f27cfc7a6abe212)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M63.258 38.732h25.96v10.484h-25.96z"
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_70688395b09a45ef61cd4b7e91a28081d507a2de75a0cdd63f27cfc7a6abe212",
    gradientUnits: "userSpaceOnUse",
    x1: 110.611,
    y1: 84.806,
    x2: 139.071,
    y2: 84.806
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_9_70688395b09a45ef61cd4b7e91a28081d507a2de75a0cdd63f27cfc7a6abe212)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M111.861 79.564h25.96v10.484h-25.96z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneralLedger);
export default __webpack_public_path__ + "static/media/generalLedger.709deed11f21c5982e044ff4e34f94f9.svg";
export { ForwardRef as ReactComponent };